import React from "react";
import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
`;

const TwoColumnGrid = (props: any) => {
  return <Grid>{props.children}</Grid>;
};
export default TwoColumnGrid;
